import {Box, Typography} from '@mui/material';

import {greenColors} from '../../../../../layouts/theme/designSystem';

export interface Props {
  label: string;
  value?: string | null;
}

export const TargetProfileDetailField = ({label, value}: Props) => {
  if (!value?.trim()) {
    return null;
  }

  return (
    <Box sx={{mb: 1.5}}>
      <Typography variant='caption' sx={{color: greenColors[700], fontWeight: 600, display: 'block'}}>
        {label}
      </Typography>
      <Typography variant='body2' sx={{whiteSpace: 'pre-wrap'}}>
        {value}
      </Typography>
    </Box>
  );
};
